// Pure helpers for Plaid's pending lane and removed rows. No React, no Graph.
//
// The sync (sharepoint-mcp finance-writer.js) never deletes a row: a
// transaction Plaid withdraws — a released hold, a reversed charge — gets
// "PLAID_REMOVED <date>" appended to Notes. Such a row is not money and must
// not reach any total, list, Runway or recurring match, so the page drops it
// at load (liveTransactions) and nothing downstream ever sees it.
//
// A pending row (IsPending true) is a charge the bank has authorised but not
// posted. It counts like any other row — the money is spoken for — and is
// swapped in place to its posted version when that arrives.

export const PLAID_REMOVED = 'PLAID_REMOVED';

export const isPlaidRemoved = (t) => String(t?.Notes || '').includes(PLAID_REMOVED);
export const isPending = (t) => t?.IsPending === true;

/** Every row except the ones Plaid withdrew. */
export function liveTransactions(rows) {
  return (rows || []).filter((t) => !isPlaidRemoved(t));
}

/** The account mask a Plaid row came from: SourceStatement "Plaid:Chase:2634" → "2634". */
export function maskOf(t) {
  const m = /:(\d{4})$/.exec(String(t?.SourceStatement || ''));
  return m ? m[1] : null;
}

/**
 * Pending money per account mask: { [mask]: { net, count } }, where net is
 * money out minus money in (positive = cash that is already spoken for).
 * Only masks with at least one pending row appear.
 */
export function pendingByMask(rows) {
  const out = {};
  for (const t of rows || []) {
    if (!isPending(t) || isPlaidRemoved(t)) continue;
    const mask = maskOf(t);
    if (!mask) continue;
    const e = (out[mask] ||= { net: 0, count: 0 });
    e.net += (t.Direction === 'In' ? -1 : 1) * (t.Amount ?? 0);
    e.count += 1;
  }
  return out;
}
